/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext, useState } from 'react';

import { IComponentProps } from 'interfaces/queries/language';

type StatusState = {
  isPending: boolean;
  isCanceled: boolean;
  isSuccess: boolean;
  closePending: boolean;
  closeCanceled: boolean;
  onCloseDrawer: () => void;
};

interface ConfirmModalContextProps {
  modalStatus: any;
  setProps: any;
  props: any;
  setUpdateStatus: any;
}

const UpdateConfirmModalContext =
  createContext<ConfirmModalContextProps | null>(null);

const UpdateConfirmModalProvider: React.FC<IComponentProps> = ({
  children,
}) => {
  const [status, setStatus] = useState<StatusState>({
    isPending: false,
    isCanceled: false,
    isSuccess: false,
    closePending: false,
    closeCanceled: false,
    onCloseDrawer: () => {
      // Add functionality
    },
  });

  const [props, setProps] = useState<any>();

  return (
    <UpdateConfirmModalContext.Provider
      value={{
        modalStatus: status,
        setProps,
        props,
        setUpdateStatus: setStatus,
      }}
    >
      {children}
    </UpdateConfirmModalContext.Provider>
  );
};

const useUpdateConfirmModal = () => {
  const languageContext = useContext(UpdateConfirmModalContext);
  if (!languageContext) {
    throw new Error('Platform configuration not available');
  }
  return languageContext;
};

export { useUpdateConfirmModal, UpdateConfirmModalProvider };
